import React, { Component } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Snackbar,
} from "@material-ui/core";
import Constants from "../App/Variables/Constants";
import { Link } from "react-router-dom";

export default class AddVariants extends Component {
  state = {
    notification: false,
    redirect: false,
    loading: false,
    product_id: "",
    size: "",
    price: "",
    quantity: "",
    offer_price: "",
    delivery_charge: "",

    variants: [
      {
        colour: "",
        images: [],
      },
    ],
  };

  componentDidMount() {
    this.setState({ product_id: window.location.pathname.split("/")[3] });
  }

  /* ---------------- VARIANT HANDLERS ---------------- */

  handleVariantChange = (index, e) => {
    const { name, value } = e.target;
    const variants = [...this.state.variants];
    variants[index][name] = value;
    this.setState({ variants });
  };

  handleVariantFile = (index, e) => {
    const variants = [...this.state.variants];
    variants[index].images = e.target.files;
    this.setState({ variants });
  };

  addVariant = () => {
    this.setState({
      variants: [
        ...this.state.variants,
        {
          colour: "",
          images: [],
        },
      ],
    });
  };

  removeVariant = (index) => {
    const variants = [...this.state.variants];
    variants.splice(index, 1);
    this.setState({ variants });
  };

  /* ---------------- COMMON INPUT ---------------- */

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  /* ---------------- SUBMIT ---------------- */

  handleSubmit = (e) => {
    e.preventDefault();

    const fd = new FormData();

    fd.append("size", this.state.size);
    fd.append("price", this.state.price);
    fd.append("quantity", this.state.quantity);
    fd.append("offer_price", this.state.offer_price);
    fd.append("delivery_charge", this.state.delivery_charge);
    fd.append("product_id", this.state.product_id);

    this.state.variants.forEach((variant, index) => {
      fd.append(`variants[${index}][colour]`, variant.colour);

      for (let i = 0; i < variant.images.length; i++) {
        fd.append(`variants[${index}][images]`, variant.images[i]);
      }
    });

    this.setState({ loading: true });

    axios
      .post(Constants.postUrls.addVariants, fd)
      .then((resp) => {
        this.setState({
          loading: false,
          notification: true,
          message: resp.data.message,
        });

        setTimeout(() => {
          this.setState({
            notification: false,
            redirect: true,
          });
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          notification: true,
          message: error?.response?.data?.message || "Error",
        });
      });
  };

  /* ---------------- RENDER ---------------- */

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: "/admin/variants/" + this.state.product_id,
          }}
        />
      );
    }

    return (
      <Container maxWidth="xl">
        <Typography variant="h5" style={{ margin: "20px 0" }}>
          Add Variant
        </Typography>

        {this.state.notification && (
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={true}
            autoHideDuration={6000}
            message={this.state.message}
          />
        )}

        <form onSubmit={this.handleSubmit}>
          {/* FIXED FIELDS */}
          <Grid container spacing={2}>
            <Grid item sm={3}>
              <TextField
                label="Size"
                name="size"
                value={this.state.size}
                onChange={this.handleInput}
                variant="outlined"
                fullWidth
                required
              />
            </Grid>

            <Grid item sm={3}>
              <TextField
                label="Price"
                name="price"
                value={this.state.price}
                onChange={this.handleInput}
                variant="outlined"
                fullWidth
                required
              />
            </Grid>

            <Grid item sm={3}>
              <TextField
                label="Offer Price"
                name="offer_price"
                value={this.state.offer_price}
                onChange={this.handleInput}
                variant="outlined"
                fullWidth
              />
            </Grid>

            <Grid item sm={3}>
              <TextField
                label="Quantity"
                name="quantity"
                value={this.state.quantity}
                onChange={this.handleInput}
                variant="outlined"
                fullWidth
                required
              />
            </Grid>

            <Grid item sm={3}>
              <TextField
                label="Delivery Charges"
                name="delivery_charge"
                value={this.state.delivery_charge}
                onChange={this.handleInput}
                variant="outlined"
                fullWidth
                required
              />
            </Grid>
          </Grid>

          <br />

          {/* 🔥 DYNAMIC COLOR + IMAGES */}
          {this.state.variants.map((variant, index) => (
            <Grid
              container
              spacing={2}
              key={index}
              style={{
                border: "1px solid #ddd",
                padding: "15px",
                marginBottom: "10px",
                borderRadius: "6px",
              }}
            >
              <Grid item sm={3}>
                <TextField
                  label="Colour"
                  name="colour"
                  value={variant.colour}
                  onChange={(e) => this.handleVariantChange(index, e)}
                  variant="outlined"
                  fullWidth
                  required
                />
              </Grid>

              <Grid item sm={6}>
                <label>Images (Multiple)</label>
                <input
                  type="file"
                  multiple
                  onChange={(e) => this.handleVariantFile(index, e)}
                />
              </Grid>

              <Grid
                item
                sm={3}
                style={{ display: "flex", alignItems: "center" }}
              >
                {this.state.variants.length > 1 && (
                  <Button
                    color="secondary"
                    onClick={() => this.removeVariant(index)}
                  >
                    Remove
                  </Button>
                )}
              </Grid>
            </Grid>
          ))}

          {/* ADD MORE COLOR */}
          <Button
            variant="outlined"
            onClick={this.addVariant}
            style={{ marginBottom: "20px" }}
          >
            + Add Colour
          </Button>

          <br />

          {/* ACTION BUTTONS */}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ marginRight: "10px" }}
          >
            {this.state.loading ? "Adding..." : "Add"}
          </Button>

          <Link to={`/admin/variants/${this.state.product_id}`}>
            <Button variant="contained" color="secondary">
              Cancel
            </Button>
          </Link>
        </form>
      </Container>
    );
  }
}

// import React, { Component } from "react";
// import axios from "axios";
// import { Redirect } from "react-router-dom";
// // import Constants from "../App/Variables/Constants";
// import {
//   Backdrop,
//   Button,
//   Container,
//   Fade,
//   Grid,
//   Box,
//   //   GridItem,
//   Modal,
//   TextField,
//   Typography,
//   Snackbar,
//   //   InputLabel,
//   //   Select,
//   //   MenuItem,
// } from "@material-ui/core";
// import init from "../helpers/WindowToken";
// import Constants from "../App/Variables/Constants";
// import EditIcon from "@material-ui/icons/Edit";
// import { Link } from "react-router-dom";
// import InputLabel from "@material-ui/core/InputLabel";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import FormControl from "@material-ui/core/FormControl";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// import { makeStyles } from "@material-ui/core";

// const classes = makeStyles();

// export default class AddVariants extends Component {
//   state = {
//     notification: false,
//     redirect: false,
//     loading: false,
//     product_id: "",
//     size: "",
//     colour: "",
//     price: 0,
//     quantity: 0,
//     images: [],
//     offer_price: 0,
//   };

//   componentDidMount() {
//     this.setState({ product_id: window.location.pathname.split("/")[3] });
//   }

//   handleSubmit = (e) => {
//     e.preventDefault();
//     const fd = new FormData();

//     fd.append("size", this.state.size);
//     fd.append("colour", this.state.colour);
//     fd.append("price", this.state.price);
//     fd.append("quantity", this.state.quantity);
//     fd.append("product_id", this.state.product_id);
//     fd.append("offer_price", this.state.offer_price);
//     if (this.state.images.length > 0) {
//       for (let i = 0; i <= this.state.images.length - 1; i++) {
//         fd.append("images", this.state.images[i]);
//       }
//     }
//     this.setState({
//       loading: true,
//     });
//     if (init() === "success") {
//       axios
//         .post(Constants.postUrls.addVariants, fd)
//         .then((resp) => {
//           // console.log(resp);
//           fd.delete("category");
//           this.setState({
//             loading: false,
//             notification: true,
//             message: resp.data.message,
//           });
//           setTimeout(() => {
//             this.setState({
//               notification: false,
//               redirect: true,
//             });
//           }, 1500);
//         })
//         .catch((error) => {
//           fd.delete("category");
//           this.setState({
//             notification: true,
//             message: error.response.data.message,
//           });
//           // console.log(error.response.data.message);
//           setTimeout(() => {
//             this.setState({
//               notification: false,
//               redirect: false,
//               loading: false,
//             });
//           }, 1500);
//         });
//     }
//   };

//   handleInput = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };

//   handleFile = (e) => {
//     console.log(e.target.files);
//     this.setState({
//       [e.target.name]: e.target.files,
//     });
//   };
//   render() {
//     if (this.state.redirect) {
//       return (
//         <Redirect
//           to={{
//             pathname: "/admin/variants/" + this.state.product_id,
//           }}
//         />
//       );
//     } else {
//       return (
//         <Container maxWidth="xl">
//           <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
//             <Grid item xs={6}>
//               <Typography variant="h5"> Add Variant </Typography>
//             </Grid>
//           </Grid>

//           {/* After Getting api add Snackbar notification here  */}
//           {this.state.notification ? (
//             <Snackbar
//               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//               open={true}
//               color={"s"}
//               autoHideDuration={6000}
//               message={this.state.message}
//             ></Snackbar>
//           ) : null}

//           <div
//             style={{
//               background: "#5b5757",
//               padding: "20px",
//               borderRadius: "10px",
//               width: "100%",
//               border: "0",
//               display: "flex",
//               position: "relative",
//               fontSize: ".875rem",
//               minWidth: "0",
//               wordWrap: " break-word",
//               boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
//               marginTop: "30px",
//               borderRadius: "6px",
//               marginBottom: "30px",
//               flexDirection: "column",
//               textAlign: "left",
//             }}
//           >
//             <div
//               style={{
//                 background:
//                   "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
//                 boxShadow:
//                   " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
//                 float: "left",
//                 padding: "15px",
//                 marginTop: "-43px",
//                 marginRight: "15px",
//                 borderRadius: "3px",
//                 backgroundColor: "#999",
//                 width: "6%",
//                 height: "60px",
//                 marginBottom: "25px",
//                 textAlign: "center",
//               }}
//             >
//               <EditIcon />
//             </div>

//             <form onSubmit={this.handleSubmit}>
//               <Grid container sm={12} spacing={2}>
//                 <Grid item sm={4}>
//                   <TextField
//                     id="outlined-basic"
//                     onChange={this.handleInput}
//                     label="Size"
//                     name="size"
//                     variant="outlined"
//                     required={true}
//                     value={this.state.size}
//                     style={{ marginRignt: "3px", width: "100%" }}
//                   />
//                 </Grid>

//                 <Grid item sm={4}>
//                   <TextField
//                     id="outlined-basic"
//                     onChange={this.handleInput}
//                     label="Colour"
//                     name="colour"
//                     variant="outlined"
//                     required={true}
//                     value={this.state.color}
//                     style={{ marginRignt: "3px", width: "100%" }}
//                   />
//                 </Grid>
//                 <Grid item sm={4}>
//                   <TextField
//                     id="outlined-basic"
//                     onChange={this.handleInput}
//                     label="Price"
//                     name="price"
//                     variant="outlined"
//                     required={true}
//                     value={this.state.price}
//                     style={{ marginRignt: "3px", width: "100%" }}
//                   />
//                 </Grid>
//                 <Grid item sm={4}>
//                   <TextField
//                     id="outlined-basic"
//                     onChange={this.handleInput}
//                     label="Price"
//                     name="offer_price"
//                     variant="outlined"
//                     // required={true}
//                     value={this.state.offer_price}
//                     style={{ marginRignt: "3px", width: "100%" }}
//                   />
//                 </Grid>
//                 <Grid item sm={4}>
//                   <TextField
//                     id="outlined-basic"
//                     onChange={this.handleInput}
//                     label="Quantity"
//                     name="quantity"
//                     variant="outlined"
//                     required={true}
//                     value={this.state.quantity}
//                     style={{ marginRignt: "3px", width: "100%" }}
//                   />
//                 </Grid>

//                 <Grid item sm={4}>
//                   <label> Select Images (Maximum 4) </label>
//                   <input
//                     type="file"
//                     name="images"
//                     multiple
//                     onChange={this.handleFile}
//                   />
//                 </Grid>
//               </Grid>

//               <br />
//               <div>
//                 <Button
//                   variant="contained"
//                   type="submit"
//                   size="small"
//                   color="primary"
//                   style={{
//                     marginRight: "20px",

//                     marginTop: "35px",
//                   }}
//                 >
//                   {this.state.loading ? "Adding.." : "Add"}
//                 </Button>
//                 <Link
//                   to={{
//                     pathname: "/admin/variants/" + this.state.product_id,
//                   }}
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Button
//                     variant="contained"
//                     type="submit"
//                     size="small"
//                     color="secondary"
//                     style={{ marginRight: "20px", marginTop: "35px" }}
//                   >
//                     Cancel
//                   </Button>
//                 </Link>
//               </div>
//             </form>
//           </div>
//         </Container>
//       );
//     }
//   }
// }
